import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionMarkCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 498C0 830 190 1000 500 1000C810 1000 1000 830 1000 498C1000 191 810 0 500 0C190 0 0 191 0 498ZM82 558V438C82 235 260 74 500 74C740 74 918 235 918 438V558C918 771 768 926 504 926C240 926 82 771 82 558ZM495 215C627 216 673 280 672 383C671 495 590 541 531 541V609H453V485C548 483 582 437 583 383C584 342 565 285 495 285C419 285 385 346 373 391L306 347C328 277 380 214 495 215ZM494 676C532 676 556 694 556 736C556 779 532 798 494 798C457 798 432 779 432 736C432 694 457 676 494 676Z" })
});
export default SvgQuestionMarkCircle;
